import { IKContext, IKUpload } from "imagekitio-react";
import React, { useRef } from "react";
import { toast } from "react-toastify";
import api from "../../../../api/axiosInstance";

interface UploadProps {
  setData: React.Dispatch<React.SetStateAction<string>>;
  children: any;
  type: any;
}

const Upload: React.FC<UploadProps> = ({ children, type, setData }) => {
  const onUploadError = () => {
    toast.error("ვერ მოხერხდა სურათის ატვირთვა");
  };

  const onUploadSuccess = (response: any) => {
    setData(response);
    toast.success("სურათი აიტვირთა");
  };

  const authenticator = async () => {
    try {
      const response = await api.get("/Auth/uploadAuth");

      const { signature, expire, token, publicKey } = response.data;
      return { signature, expire, token, publicKey };
    } catch (error: any) {
      console.error("Authentication error:", error);

      const errorMessage = error.response?.data || error.message;
      throw new Error(`Authentication request failed: ${errorMessage}`);
    }
  };

  const ref = useRef<HTMLInputElement | null>(null);

  return (
    <IKContext
      publicKey={process.env.REACT_APP_IK_PUBLIC_KEY}
      urlEndpoint={process.env.REACT_APP_IK_URL_ENDPOINT}
      authenticator={authenticator}
    >
      <IKUpload
        useUniqueFileName
        onError={onUploadError}
        onSuccess={onUploadSuccess}
        className="hidden"
        ref={ref}
        accept={`${type}/*`}
      />
      <div className="cursor-pointer" onClick={() => ref.current?.click()}>
        {children}
      </div>
    </IKContext>
  );
};

export default Upload;
